import { getFibonacciSequence } from 'fibonaccisequencecomponent';
import { usersService } from '../services';
import { fileStatus } from '../constants/files/status';

const calculateTime = (number, multiplier) => {
    return number * multiplier;
};

async function checkFileStatus (opts, timeLimit, multiplier) {
    const sequence = getFibonacciSequence(10);
    let index = 1;
    let accumulatedTime = 0;
    let file;
    let endFlag = true;

    do {
        // eslint-disable-next-line no-loop-func
        await new Promise(resolve => setTimeout(resolve, calculateTime(sequence[index], multiplier) * 1000));

        file = await usersService.getFiles(opts);
        const status = file[0].metadata && file[0].metadata.status;

        if (status && status === fileStatus.pointed) {
            endFlag = false;
        }

        accumulatedTime += calculateTime(sequence[index], multiplier);
        index++;

        if (index >= sequence.length) {
            break;
        }
    } while (accumulatedTime < timeLimit && endFlag);

    return file;
}

export { calculateTime, checkFileStatus };
